import { render, staticRenderFns } from "./ImportanceSorter.vue?vue&type=template&id=5224db4c&"
import script from "./ImportanceSorter.vue?vue&type=script&lang=js&"
export * from "./ImportanceSorter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports